export default {
  decimalDigits: 12,
};
